import React, {useEffect, useState} from 'react'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import star_icon from '../../assets/images/icons/star-icon.png'






const GreenRadio = withStyles({
    root: {
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);



const Index = (props)=>{


  useEffect(()=>{

  },[props.titleValue])
    return(
        <div className="dashboard-textfield-container">
            <div className="dashboard-textfield-title">
                <span className="general-span-text">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
            <FormControl component="fieldset">
                  <RadioGroup  
                    style={{
                      display: 'flex',
                      width: '100%',
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                    aria-label="gender" 
                    name="gender1" 
                    value={props.titleValue || ''} 
                    onChange={props.handleTitleChange}>
                    <FormControlLabel value="mr" control={<GreenRadio />} label="Mr." labelPlacement="bottom"/>
                    <FormControlLabel value="mrs" control={<GreenRadio />} label="Mrs." labelPlacement="bottom"/>
                    <FormControlLabel value="miss" control={<GreenRadio />} label="Miss" labelPlacement="bottom"/>
                    <FormControlLabel value="dr" control={<GreenRadio />} label="Dr" labelPlacement="bottom"/>
                    <FormControlLabel value="other" control={<GreenRadio />} label="Other" labelPlacement="bottom"/>
                  </RadioGroup>
              </FormControl>
        </div>

    )
}

export default Index